module.exports = __webpack_public_path__ + "static/img/GettyImages-663800200.d4bf1fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/GettyImages-663800200.jpg
// module id = mEUV
// module chunks = 0